module.exports = __webpack_public_path__ + "./images/green_thumb.ef4e05.jpg";